<template>
  <section class="top-header w-100 ">
    <bannerHeader/>
    <div
      class="main-container d-flex justify-content-between align-items-center"
    >
      <div class="d-flex align-items-center" style="gap: 8px;">
        <NavButton @click="$emit('openRespMenu')" />
      <AtlasLogo />
      </div>
      <searchBox class="d-none d-lg-inline-block "/>
      <div class="d-flex align-items-center btns-header" >
        <button
          type="button"
          class="d-lg-none inline-block  bg-none "
          @click="showCloseSearchBox()"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="11.7666"
              cy="11.7666"
              r="8.98856"
              stroke="#200E32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></circle>
            <path
              d="M18.0183 18.4851L21.5423 22"
              stroke="#200E32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>

        
        <div
          class="d-inline-block"
          :class="
            notifications && notifications.items && notifications.items.length
              ? 'ml-4'
              : 'ml-1'
          "
          v-if="!mediaQueries.mobileSize"
        >
          
          <HeaderNotification
            v-if="notifications"
            v-show="
              notifications && notifications.items && notifications.items.length
            "
            v-model="notifications"
          />
        </div>
        <CartButton />
        <button
          v-if="!isLogin"
          type="button"
          class="  login-btn"
          data-toggle="modal"
          data-target="#loginModal"
        >
          <!-- <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.5 12.5537C12.2546 12.5537 14.4626 10.3171 14.4626 7.52684C14.4626 4.73663 12.2546 2.5 9.5 2.5C6.74543 2.5 4.53737 4.73663 4.53737 7.52684C4.53737 10.3171 6.74543 12.5537 9.5 12.5537ZM9.5 15.0152C5.45422 15.0152 2 15.6621 2 18.2464C2 20.8298 5.4332 21.5 9.5 21.5C13.5448 21.5 17 20.8531 17 18.2687C17 15.6844 13.5668 15.0152 9.5 15.0152ZM19.8979 9.58786H21.101C21.5962 9.58786 22 9.99731 22 10.4995C22 11.0016 21.5962 11.4111 21.101 11.4111H19.8979V12.5884C19.8979 13.0906 19.4952 13.5 18.999 13.5C18.5038 13.5 18.1 13.0906 18.1 12.5884V11.4111H16.899C16.4027 11.4111 16 11.0016 16 10.4995C16 9.99731 16.4027 9.58786 16.899 9.58786H18.1V8.41162C18.1 7.90945 18.5038 7.5 18.999 7.5C19.4952 7.5 19.8979 7.90945 19.8979 8.41162V9.58786Z"
              fill="#200E32"
            ></path>
          </svg> -->
          <span class="d-flex d-md-none">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11.5789" cy="7.27803" r="4.77803" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.00002 18.7014C3.99873 18.3655 4.07385 18.0337 4.2197 17.7311C4.67736 16.8158 5.96798 16.3307 7.03892 16.111C7.81128 15.9462 8.59431 15.836 9.38217 15.7815C10.8408 15.6533 12.3079 15.6533 13.7666 15.7815C14.5544 15.8367 15.3374 15.9468 16.1099 16.111C17.1808 16.3307 18.4714 16.77 18.9291 17.7311C19.2224 18.3479 19.2224 19.064 18.9291 19.6808C18.4714 20.6419 17.1808 21.0812 16.1099 21.2918C15.3384 21.4634 14.5551 21.5766 13.7666 21.6304C12.5794 21.7311 11.3866 21.7494 10.1968 21.6854C9.92221 21.6854 9.65677 21.6854 9.38217 21.6304C8.59663 21.5773 7.81632 21.4641 7.04807 21.2918C5.96798 21.0812 4.68652 20.6419 4.2197 19.6808C4.0746 19.3747 3.99955 19.0401 4.00002 18.7014Z" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
          </span>
          <span class="d-none d-md-flex">
          ورود و عضویت

          </span>
        </button>
        <LoginUser v-if="isLogin" :atlasTheme="true" />
      </div>
    </div>
    <div class="main-container mt-2 d-lg-block d-none">
  <Nav></Nav>

    </div>
  </section>
  <!-- <section class="top-header py-3  ">
    <div
      class="main-container d-flex justify-content-lg-between align-items-baseline"
    >
<div class=" topheader">
  <NavButton @click="$emit('openRespMenu')" />
  <AtlasLogo /> 
  <div
    class="d-inline-block"
    :class="
      notifications && notifications.items && notifications.items.length
        ? 'ml-4'
        : 'ml-1'
    "
    v-if="mediaQueries.mobileSize"
  >
    <CartButton />
   
    <HeaderNotification
      v-if="notifications"
      v-show="notifications.items && notifications.items.length"
      v-model="notifications"
    />
  </div>
  <Nav></Nav>
</div>
      <div class="d-flex align-items-center" style="gap: 12px;">

        <button
          type="button"
          class="d-md-inline-block d-none bg-none "
          @click="showCloseSearchBox()"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="11.7666"
              cy="11.7666"
              r="8.98856"
              stroke="#200E32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></circle>
            <path
              d="M18.0183 18.4851L21.5423 22"
              stroke="#200E32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
       

       
       

        <button
          v-if="!isLogin"
          type="button"
          class="d-md-inline-block d-none bg-none "
          data-toggle="modal"
          data-target="#loginModal"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.5 12.5537C12.2546 12.5537 14.4626 10.3171 14.4626 7.52684C14.4626 4.73663 12.2546 2.5 9.5 2.5C6.74543 2.5 4.53737 4.73663 4.53737 7.52684C4.53737 10.3171 6.74543 12.5537 9.5 12.5537ZM9.5 15.0152C5.45422 15.0152 2 15.6621 2 18.2464C2 20.8298 5.4332 21.5 9.5 21.5C13.5448 21.5 17 20.8531 17 18.2687C17 15.6844 13.5668 15.0152 9.5 15.0152ZM19.8979 9.58786H21.101C21.5962 9.58786 22 9.99731 22 10.4995C22 11.0016 21.5962 11.4111 21.101 11.4111H19.8979V12.5884C19.8979 13.0906 19.4952 13.5 18.999 13.5C18.5038 13.5 18.1 13.0906 18.1 12.5884V11.4111H16.899C16.4027 11.4111 16 11.0016 16 10.4995C16 9.99731 16.4027 9.58786 16.899 9.58786H18.1V8.41162C18.1 7.90945 18.5038 7.5 18.999 7.5C19.4952 7.5 19.8979 7.90945 19.8979 8.41162V9.58786Z"
              fill="#200E32"
            ></path>
          </svg>
        </button>
        <div
          class="d-inline-block"
          :class="
            notifications && notifications.items && notifications.items.length
              ? 'ml-4'
              : 'ml-1'
          "
          v-if="!mediaQueries.mobileSize"
        >
          <CartButton />
          <HeaderNotification
            v-if="notifications"
            v-show="
              notifications && notifications.items && notifications.items.length
            "
            v-model="notifications"
          />
        </div>
        <LoginUser
          v-if="isLogin"
          :atlasTheme="true"
        />
        
      </div>
    </div>
  </section> -->
</template>

<script>
import Nav from "@/parts/Front/components/Nav";
import LoginUser from "@/parts/Front/components/LoginUser";
import AtlasLogo from "@/parts/Front/components/AtlasLogo";
import { cartListsOpen, openSearch } from "@/libraries/functions";
import findUrl from "@/libraries/links/LinkResolver";
import CartButton from "@/parts/Front/components/cart/CartButton";
import HeaderNotification from "@/parts/Front/components/notification/HeaderNotification";
import SearchButton from "./header/SearchButton";
import NavButton from "@/parts/Front/components/shared/NavButton";
import searchBox from "@/parts/Front/components/searchBoxHeader";
import bannerHeader from "./shared/bannerHeader.vue";

export default {
  name: "TopHeader",
  inject: ["mediaQueries"],
  components: {
    NavButton,
    SearchButton,
    searchBox,
    HeaderNotification,
    CartButton,
    AtlasLogo,
    LoginUser,
    Nav,
    bannerHeader
 
  },
  data() {
    return {
      showOptions: false,
    };
  },
  methods: {
    findUrl,
    // cartListsCloseBody(){
    //   const cartLists=document.getElementsByClassName('cart-lists')[0];
    //   const cartListsCloseResp = document.getElementsByClassName('cart-lists-close-resp')[0];
    //   cartListsCloseResp.style.display="none";
    //   cartLists.style.left="-390px";
    // },
    cartListsOpen,
    showCloseSearchBox() {
      openSearch();
    },
  },
  mounted() {},
  computed: {
    menu() {
      if (this.$store.getters["front/getHomeData"] != null) {
        return this.$store.getters["front/getHomeData"].menu.header;
      } else {
        return this.$store.getters["front/getHomeData"];
      }
    },
    status() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    notifications() {
      return this.$store.getters["front/getNotifications"];
    },
  },
};
</script>

<style scoped>
.btns-header{
  gap: 8px;
}
.login-btn{
  background-color: var(--newTheme-color);
  color: #fff;
  border-radius: 28px;
    font-size: 15px;
    padding: 6px 24px;

}
/* افزودن استایل به کدهای اضافه شده */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.childMenu {
  color: #666;
}
.topheader {
  display: flex;
  gap: 15px;
  align-items: center;
  width: 100%;
}

@media screen and (max-width: 768px) {
  .topheader {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    align-items: center;
    width: 100%;
  }
  .login-btn{
  background-color: unset;

  border-radius: 0;
    font-size: 15px;
    padding: 0;

}
}
#menuSkelton {
  display: flex;
  justify-content: space-around;
  width: 300px;
}
#menuSkelton div {
  width: 50px;
  height: 30px;
}
</style>
